// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

// @constants
const actionTypes = require('../raConstants/actionTypes');

const requestSimulationInProgress = () => ({
    type: actionTypes.RA_SIMULATION_REQUEST,
});

const buildEmptySimulation = () => ({
    hasRecurringTransfer: false,
    endDate: '',
    name: '',
    type: 'ERROR',
    id: '001',
    error: true,
});

const requestSimulationSuccess = data => {
    const formattedData = !!data ? data : buildEmptySimulation();
    Object.keys(formattedData).forEach(
        key => formattedData[key] == null && delete formattedData[key],
    );
    return {
        type: actionTypes.RA_SIMULATION_REQUEST_SUCCESS,
        payload: formattedData,
    };
};

const requestSimulationFailure = () => ({
    type: actionTypes.RA_SIMULATION_REQUEST_FAILURE,
});

const updateSimulation = update => ({
    type: actionTypes.RA_SIMULATION_UPDATE_SIMULATION,
    payload: update,
});

const requestSimulation = (pureRobo = false, onSuccess) => dispatch => {
    const requestData = {
        header: { version: 2 },
        query: {
            pureRobo: pureRobo,
        },
    };

    dispatch(requestSimulationInProgress());

    return APIGet(dispatch, apiURLBuilder.getURL('raSimulation'), requestData)
        .then(response => {
            dispatch(requestSimulationSuccess(response));
            onSuccess && onSuccess();
        })
        .catch(error => {
            if (error.error && error.error.status == 404) {
                dispatch(requestSimulationSuccess(buildEmptySimulation()));
            } else {
                dispatch(requestSimulationFailure());
            }
        });
};

const resetObjectiveValueOfSaveSimulation = () => ({
    type: actionTypes.RA_SAVE_SIMULATION_OBJECTIVE_VALUE_RESET,
});

module.exports = {
    updateSimulation,
    requestSimulation,
    resetObjectiveValueOfSaveSimulation,
};
